import React, { useState } from 'react';

import Loader from 'react-loader-spinner';
import { useList } from '../../hooks/listHook';
import EmptyList from '../../useful/EmptyList';
import { withAuthorization } from '../../session';
import ModalInfo from '../../useful/ModalInfo';
import ModalForm from '../../useful/ModalForm';
import AdForm from './AdForm';
import AdItem from './AdItem';
import AdEditForm from './AdEditForm';

const AdList = (props) => {

    const { loading, list } = useList(props.firebase.adsList(), null)
    const [modal, setModal] = useState({ show: false, title: '', message: '' });
    const [adEditForm, setAdEditForm] = useState({ show: false, ad: {} });

    const showModal = (title, message) => {
        setModal({ show: true, title, message });
    }

    const showAdEditForm = (ad) => {
        setAdEditForm({ show: true, ad: ad });
    }

    const listView = (list && list.length > 0) ?
        list.map((item, i) =>
            <AdItem key={i} ad={item} showModal={showModal} showAdEditForm={showAdEditForm} />
        )
        :
        <EmptyList />

    return (
        <div>
            <div className="mb-3">
                <AdForm showModal={showModal} />
            </div>

            <div className="">
                {/* <div className="bg-white border rounded-lg p-2"> */}
                {/* <h6 className="font-weight-bolder">Listado de usuarios</h6> */}

                {(!loading) ?
                    listView
                    :
                    <div className="nav justify-content-center row">
                        <Loader className="mt-4"
                            type="ThreeDots"
                            color="#263238"
                            height={60}
                            width={60}
                            timeout={0} />
                    </div>
                }

            </div>

            <ModalInfo
                data={modal}
                onClose={() => setModal({ show: false, title: '', message: '' })}
            />

            <ModalForm
                show={adEditForm.show}
                onClose={() => setAdEditForm({ show: false, ad: {} })}
            >
                <AdEditForm ad={adEditForm.ad}
                    onClose={() => setAdEditForm({ show: false, ad: {} })} showModal={showModal} />
            </ModalForm>

        </div>
    )


}

const condition = authUser => {
    if (!!authUser) {
        return authUser.token.admin === true;
    } else
        return false;
};
export default withAuthorization(condition)(AdList);